module.exports = __webpack_public_path__ + "img/27.c06633a2.svg";